import { Stack, Typography } from "@mui/material"
import { AvatarIcon, BuildingIcon, RfidCardIcon } from "assets/icons"
import { Loader } from "components/Loader"
import { MainPageContentContainer } from "components/MainPageContentContainer"
import { OreveChipInfo } from "components/OreveChip"
import { OreveStatus } from "components/status"
import { useEffect } from "react"
import { useMmsService } from "services/mms/context/MmsServiceContext"
import { EntityInfo } from "types/entity"

export const EntityPage = () => {
    const { profileService } = useMmsService()
    const { useGetSelfEntity } = profileService
    const {
        data,
        isLoading,
        success,
        sendRequest: fetchEntity,
    } = useGetSelfEntity()

    useEffect(() => {
        fetchEntity()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <MainPageContentContainer
            sx={{
                maxWidth: "max(500px, 50%)",
                p: "1.5rem",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {isLoading ? (
                <Loader />
            ) : success && data !== null ? (
                <EntityPageView {...(data as EntityInfo)} />
            ) : null}
        </MainPageContentContainer>
    )
}

interface EntityPageViewProps {
    entity_name: string
    company_name: string
    siret: string
    tvaintra: string
    address: string
    zip_code: string
    city: string
    numberOfDrivers: number
    numberOfCards: number
}

const EntityPageView = ({
    entity_name,
    company_name,
    siret,
    tvaintra,
    address,
    zip_code,
    city,
    numberOfDrivers,
    numberOfCards,
}: EntityPageViewProps) => {
    const fullAddress = `${address} - ${zip_code} - ${city}`
    return (
        <>
            <Stack direction="column" gap="1rem" sx={{ width: "100%" }}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="titleLarge">{entity_name}</Typography>
                    <OreveStatus
                        variant="info"
                        icon={<BuildingIcon />}
                        content="Siège social"
                        sx={{ transform: "translate(5px, -5px)" }}
                    />
                </Stack>
                <Stack direction="row" justifyContent="start" gap="0.6rem">
                    <OreveChipInfo
                        icon={<AvatarIcon />}
                        label={`${numberOfDrivers} utilisateurs`}
                    />
                    <OreveChipInfo
                        icon={<RfidCardIcon />}
                        label={`${numberOfCards} cartes de recharge`}
                    />
                </Stack>
                <div>
                    <EntityInfoComponent
                        label="Raison sociale"
                        content={company_name}
                    />
                    <EntityInfoComponent label="N° SIRET" content={siret} />
                    <EntityInfoComponent label="N° TVA" content={tvaintra} />
                    <EntityInfoComponent
                        label="Adresse"
                        content={fullAddress}
                    />
                </div>
                <Typography variant="bodySmall">
                    Cette adresse sera utilisée pour la livraison et la
                    facturation. <br />
                    En cas de modification de ces informations veuillez
                    contacter le service client.
                </Typography>
            </Stack>
        </>
    )
}

const EntityInfoComponent = ({
    label,
    content,
}: {
    label: string
    content: string
}) => {
    return (
        <div style={{ display: "flex" }}>
            <Typography variant="labelLarge">{label} :&nbsp;</Typography>
            <Typography variant="body">{content}</Typography>
        </div>
    )
}
